import { Button, Divider, HStack, Stack, Text, VStack } from "@chakra-ui/react";
import React from "react";
import { LogoIcon } from "../../icons/LogoIcon";

interface FooterProps {
  hasSectionBtn?: boolean;
}

export const Footer: React.FC<FooterProps> = ({ hasSectionBtn = true }) => {
  return (
    <VStack w="full" gap={4}       mt={hasSectionBtn ? ["40px", "40px", "120px"] : "6px"}>
      {hasSectionBtn && (<Stack
        flexDirection={["column", "column", "row"]}
        w="80%"
        justifyContent="space-between"
        alignItems={["flex-start", 'flex-start","center']}
        gap="10px"
      >
        <Button variant="unstyled" color="#fff">
          <a href="#about" style={{ color: "#fff" }}>
            Quiero viajar
          </a>
        </Button>
        <Button variant="unstyled" color="#fff">
          <a href="#driver" style={{ color: "#fff" }}>
            Quiero conducir
          </a>
        </Button>
        <Button variant="unstyled" color="#fff">
          <a href="#corporations" style={{ color: "#fff" }}>
            Empresas
          </a>
        </Button>
        <Button variant="unstyled" color="#fff">
          <a href="#download">Descargar</a>
        </Button>
        {/* <Button variant='unstyled'>Cotizador</Button> */}
        {/* <Button variant="unstyled" color="#fff">
          
          Términos y condiciones
        
        </Button> */}
        <Button variant="unstyled" color="#fff">
          <a
            href="https://api.viajaya.app/auth/policy"
            target="_blank"
            rel="noreferrer"
          >
            Política de privacidad
          </a>
        </Button>
      </Stack>)}
      <Divider w="80%" h="1px" bgColor="primary.600" />
      <HStack w="80%" justifyContent="space-between" alignItems="center">
        <LogoIcon h={20} w={20} />
        <Text fontSize="14px" color="primary.600">
          © 2024 ViajáYa
        </Text>
      </HStack>
    </VStack>
  );
};
